"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingCartKeys = void 0;
// keys from Booking that get transferred to the cart on creation
const bookingCartKeys = exports.bookingCartKeys = ['amountAdults', 'amountBabies', 'amountChildren', 'amountPets', 'amountYouths', 'arrivalDate', 'departureDate'];